import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "../../utils/helpers/moment";
import Select from "../Select";
import ValidationInput from "../ValidationInput";
import ValidationDatePicker from "../ValidationDatePicker/beneficiaire";
import { ForceToTopDom } from '../../utils/helpers/scrollToTop'

class BeneficiaireBox extends Component {
  static propTypes = {
    beneficiaireData: PropTypes.object.isRequired,
    beneficiairePosition: PropTypes.number.isRequired,
    removeBeneficiaire: PropTypes.func.isRequired,
    checkYesAddSouscripteur: PropTypes.func.isRequired,
    checkNoAddSouscripteur: PropTypes.func.isRequired,
    checkChangeBeneficiaire: PropTypes.func.isRequired,
    checkFormValid: PropTypes.func.isRequired,
    hasSouscripteurAdded: PropTypes.bool.isRequired,
    isEntreprise: PropTypes.bool.isRequired
  };

  constructor (props) {
    super(props)
    let birthday =  props.beneficiaireData.birthday ? moment(props.beneficiaireData.birthday,"DD-MMM-YYYY") : null
    this.state = { startBirthday: birthday, form: [] }
    this.handleChangeDatePickerBirthday = this.handleChangeDatePickerBirthday.bind(this)
  }

  componentWillUpdate(nextProps, nextState) {
    const { beneficiaireData } = nextProps

    if (beneficiaireData.birthday) {
      if (beneficiaireData.birthday !== this.props.beneficiaireData.birthday) {
        let thisBirthday = moment(beneficiaireData.birthday,"DD-MMM-YYYY").format()
        this.handleChangeDatePickerBirthday(moment(thisBirthday))
      }
    }
  }

  handleChangeDatePickerBirthday(date) {
    const { beneficiairePosition, checkChangeBeneficiaire } = this.props
    let name = "birthday"
    this.setState({ startBirthday: date })
    checkChangeBeneficiaire(moment(date).format("DD-MMM-YYYY"), name, beneficiairePosition - 1)
  }

  handleDeleteBeneficiaire = (event) => {
    event.preventDefault();
    const {
      beneficiaireData,
      beneficiairePosition,
      removeBeneficiaire
    } = this.props;
    if (beneficiaireData._id) {
      removeBeneficiaire(beneficiaireData._id, beneficiairePosition - 1);
    } else {
      removeBeneficiaire(null, beneficiairePosition - 1);
    }
  }

  handleSouscripteurYesAdd = event => {
    event.preventDefault();
    const { beneficiairePosition, checkYesAddSouscripteur } = this.props;
    checkYesAddSouscripteur(beneficiairePosition - 1);
  };

  handleSouscripteurNoAdd = event => {
    event.preventDefault();
    const { beneficiairePosition, checkNoAddSouscripteur } = this.props;
    checkNoAddSouscripteur(beneficiairePosition - 1);
  };
  handleOnError = (event, errorPayload) => {
    let err = errorPayload;
    this.setState((prev, props) => {
      prev.form[err.name] = !err.hasError;
      const position = props.beneficiairePosition - 1;
      this.props.checkFormValid(
        position,
        Object.values(prev.form).reduce((a, b) => a && b)
      );
      return { form: prev.form };
    });
  };
  handleSaveBeneficiaire = (value, name, position, errorPayload) => {
    const { checkChangeBeneficiaire } = this.props;
    let err = errorPayload;
    this.setState((prev, props) => {
      prev.form[err.name] = !err.hasError;
      const position = props.beneficiairePosition - 1;
      this.props.checkFormValid(
        position,
        Object.values(prev.form).reduce((a, b) => a && b)
      );
      return { form: prev.form };
    });
    checkChangeBeneficiaire(value, name, position);
  };

  render() {
    const { beneficiaireData, beneficiairePosition, hasSouscripteurAdded, isEntreprise } = this.props
    const { startBirthday } = this.state
    let isOpenBox = beneficiaireData.beneficiareOpen ? 'uk-open' : ''

    return(

      <li className={isOpenBox}>
        <h3 className="uk-accordion-title uk-text-left aps-dashboard-beneficiare-accordion-title"
            onClick={(event) => ForceToTopDom()}
        >
          Bénéficiaire {beneficiairePosition}
        </h3>
        <div className="uk-accordion-content aps-dashboard-beneficiare-accordion-content">
          {beneficiaireData._id ? (
            <div className="answer-souscription-beneficiaire">
              {beneficiaireData.lien &&
                <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                  <p className="uk-text-left aps-section-contacter-fields-name">
                    Lien de parenté ou professionnel
                  </p>
                  <div className="uk-inline aps-section-register-fields-full">
                    <Select
                      defaultValue={
                        beneficiaireData.lien && beneficiaireData.lien
                      }
                      name="lien"
                      data={(isEntreprise && beneficiairePosition === 1) ? {
                        "*": "Veuillez choisir un lien de parenté",
                        employe: "Employé",
                        conjoint: "Conjoint",
                        enfant: "Enfant",
                      } : (isEntreprise && beneficiairePosition !== 1) ? {
                        "*": "Veuillez choisir un lien de parenté",
                        conjoint: "Conjoint",
                        enfant: "Enfant",
                      } : {
                        "*": "Veuillez choisir un lien de parenté",
                        assurePrincipal: "Assuré principal",
                        conjoint: "Conjoint",
                        enfant: "Enfant",
                        employe: "Employé",
                        autre: "Autre",
                      }}
                      onBlur={(errorPayload, event) =>
                        this.handleOnError(event, errorPayload)
                      }
                      onChange={(errorPayload, event) =>
                        this.handleSaveBeneficiaire(
                          event.target.value,
                          event.target.name,
                          beneficiairePosition - 1,
                          errorPayload
                        )
                      }
                    />
                  </div>
                </div>
              }
              <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                <p className="uk-text-left aps-section-contacter-fields-name">
                  Nom
                </p>
                <div className="uk-inline aps-section-register-fields-full">
                  <ValidationInput
                    type="text"
                    placeholder="Nom"
                    name="firstname"
                    defaultValue={
                      beneficiaireData.firstname && beneficiaireData.firstname
                    }
                    onBlur={(errorPayload, event) =>
                      this.handleOnError(event, errorPayload)
                    }
                    onChange={(errorPayload, event) =>
                      this.handleSaveBeneficiaire(
                        event.target.value,
                        event.target.name,
                        beneficiairePosition - 1,
                        errorPayload
                      )
                    }
                  />
                </div>
              </div>
              <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                <p className="uk-text-left aps-section-contacter-fields-name">
                  Prénom(s)
                </p>
                <div className="uk-inline aps-section-register-fields-full">
                  <ValidationInput
                    type="text"
                    placeholder="Prénom(s)"
                    name="lastname"
                    defaultValue={
                      beneficiaireData.lastname && beneficiaireData.lastname
                    }
                    onBlur={(errorPayload, event) =>
                      this.handleOnError(event, errorPayload)
                    }
                    onChange={(errorPayload, event) =>
                      this.handleSaveBeneficiaire(
                        event.target.value,
                        event.target.name,
                        beneficiairePosition - 1,
                        errorPayload
                      )
                    }
                  />
                </div>
              </div>
              <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                <p className="uk-text-left aps-section-contacter-fields-name">
                  Date de naissance :
                </p>
                <div className="uk-inline aps-section-register-fields-full aps-section-register-fields-full-date-picker">
                  <ValidationDatePicker
                    dateFormat="DD-MMM-YYYY"
                    name="birthday"
                    placeholderText="ex: 12 Mai 1991"
                    locale="fr"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={startBirthday}
                    maxDate={moment().add(0, 'd')}
                    onBlur={(errorPayload, event) =>
                      this.handleOnError(event, errorPayload)
                    }
                    onChange={(errorPayload, date) =>
                      this.handleChangeDatePickerBirthday(date)
                    }
                  />
                </div>
              </div>
              <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                <p className="uk-text-left aps-section-contacter-fields-name">
                  Nationalité
                </p>
                <div className="uk-inline aps-section-register-fields-full">
                  <ValidationInput
                    className="uk-input aps-section-register-fields"
                    type="text"
                    placeholder="ex: Béninoise"
                    name="nationality"
                    defaultValue={
                      beneficiaireData.nationality &&
                      beneficiaireData.nationality
                    }
                    onBlur={(errorPayload, event) =>
                      this.handleOnError(event, errorPayload)
                    }
                    onChange={(errorPayload, event) =>
                      this.handleSaveBeneficiaire(
                        event.target.value,
                        event.target.name,
                        beneficiairePosition - 1,
                        errorPayload
                      )
                    }
                  />
                </div>
              </div>
              <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                <p className="uk-text-left aps-section-contacter-fields-name">
                  Sexe
                </p>
                <div className="uk-inline aps-section-register-fields-full">
                  <Select
                    name="sex"
                    defaultValue={beneficiaireData.sex && beneficiaireData.sex}
                    data={{
                      "*": "Veuillez choisir dans la liste",
                      masculin: "Masculin",
                      feminin: "Feminin"
                    }}
                    onBlur={(errorPayload, event) =>
                      this.handleOnError(event, errorPayload)
                    }
                    onChange={(errorPayload, event) =>
                      this.handleSaveBeneficiaire(
                        event.target.value,
                        event.target.name,
                        beneficiairePosition - 1,
                        errorPayload
                      )
                    }
                  />
                </div>
              </div>
              <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                <p className="uk-text-left aps-section-contacter-fields-name">
                  Taille (Cm)
                </p>
                <div className="uk-inline aps-section-register-fields-full">
                  <ValidationInput
                    type="number"
                    placeholder="ex: 173"
                    name="taille"
                    defaultValue={
                      beneficiaireData.taille && beneficiaireData.taille
                    }
                    onBlur={(errorPayload, event) =>
                      this.handleOnError(event, errorPayload)
                    }
                    onChange={(errorPayload, event) =>
                      this.handleSaveBeneficiaire(
                        event.target.value,
                        event.target.name,
                        beneficiairePosition - 1,
                        errorPayload
                      )
                    }
                  />
                </div>
              </div>
              <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                <p className="uk-text-left aps-section-contacter-fields-name">
                  Poids (Kg)
                </p>
                <div className="uk-inline aps-section-register-fields-full">
                  <ValidationInput
                    type="number"
                    placeholder="ex: 68"
                    name="poids"
                    defaultValue={
                      beneficiaireData.poids && beneficiaireData.poids
                    }
                    onBlur={(errorPayload, event) =>
                      this.handleOnError(event, errorPayload)
                    }
                    onChange={(errorPayload, event) =>
                      this.handleSaveBeneficiaire(
                        event.target.value,
                        event.target.name,
                        beneficiairePosition - 1,
                        errorPayload
                      )
                    }
                  />
                </div>
              </div>
              <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                <p className="uk-text-left aps-section-contacter-fields-name">
                  Profession
                </p>
                <div className="uk-inline aps-section-register-fields-full">
                  <ValidationInput
                    type="text"
                    placeholder="ex: Comptable"
                    name="profession"
                    defaultValue={
                      beneficiaireData.profession && beneficiaireData.profession
                    }
                    onBlur={(errorPayload, event) =>
                      this.handleOnError(event, errorPayload)
                    }
                    onChange={(errorPayload, event) =>
                      this.handleSaveBeneficiaire(
                        event.target.value,
                        event.target.name,
                        beneficiairePosition - 1,
                        errorPayload
                      )
                    }
                  />
                </div>
              </div>
              <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                <p className="uk-text-left aps-section-contacter-fields-name">
                  Formule santé
                </p>
                <div className="uk-inline aps-section-register-fields-full">
                  <Select
                    name="formule"
                    data={{
                      "*": "Veuillez choisir une Formule santé",
                      premier: "Premier",
                      vitalite: "Vitalité",
                      prestige: "Prestige"
                    }}
                    defaultValue={
                      beneficiaireData.formule && beneficiaireData.formule
                    }
                    onBlur={(errorPayload, event) =>
                      this.handleOnError(event, errorPayload)
                    }
                    onChange={(errorPayload, event) =>
                      this.handleSaveBeneficiaire(
                        event.target.value,
                        event.target.name,
                        beneficiairePosition - 1,
                        errorPayload
                      )
                    }
                  />
                </div>
              </div>
              <br />
              <div className="uk-text-center aps-dashboard-beneficiare-accordion-action-btn">
                  <button
                    className="uk-button aps-btn-silver aps-btn-silver-dashboard-btn"
                    onClick={(event) => this.handleDeleteBeneficiaire(event)}
                    >
                    Supprimer
                  </button>
                </div>
              <br />
            </div>
          ) : (
            <div>
              {beneficiaireData.isSouscripteurNoAdd ? (
                <div className="answer-souscription-beneficiaire">
                  <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                    <p className="uk-text-left aps-section-contacter-fields-name">
                      Lien de parenté ou professionnel
                    </p>
                    <div className="uk-inline aps-section-register-fields-full">
                      <Select
                        name="lien"
                        data={{
                          "*": "Veuillez choisir un lien de parenté",
                          assurePrincipal: "Assuré principal",
                          conjoint: "Conjoint",
                          enfant: "Enfant",
                          employe: "Employé",
                          autre: "Autre",
                        }}
                        onBlur={(errorPayload, event) =>
                          this.handleOnError(event, errorPayload)
                        }
                        onChange={(errorPayload, event) =>
                          this.handleSaveBeneficiaire(
                            event.target.value,
                            event.target.name,
                            beneficiairePosition - 1,
                            errorPayload
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                    <p className="uk-text-left aps-section-contacter-fields-name">
                      Nom
                    </p>
                    <div className="uk-inline aps-section-register-fields-full">
                      <ValidationInput
                        type="text"
                        placeholder="Nom"
                        name="firstname"
                        onBlur={(errorPayload, event) =>
                          this.handleOnError(event, errorPayload)
                        }
                        onChange={(errorPayload, event) =>
                          this.handleSaveBeneficiaire(
                            event.target.value,
                            event.target.name,
                            beneficiairePosition - 1,
                            errorPayload
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                    <p className="uk-text-left aps-section-contacter-fields-name">
                      Prénom(s)
                    </p>
                    <div className="uk-inline aps-section-register-fields-full">
                      <ValidationInput
                        type="text"
                        placeholder="Prénom(s)"
                        name="lastname"
                        onBlur={(errorPayload, event) =>
                          this.handleOnError(event, errorPayload)
                        }
                        onChange={(errorPayload, event) =>
                          this.handleSaveBeneficiaire(
                            event.target.value,
                            event.target.name,
                            beneficiairePosition - 1,
                            errorPayload
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                    <p className="uk-text-left aps-section-contacter-fields-name">
                      Date de naissance :
                    </p>
                    <div className="uk-inline aps-section-register-fields-full aps-section-register-fields-full-date-picker">
                      <ValidationDatePicker
                        dateFormat="DD-MMM-YYYY"
                        name="birthday"
                        placeholderText="ex: 12 Mai 1991"
                        locale="fr"
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        selected={startBirthday}
                        maxDate={moment().add(0, 'd')}
                        onBlur={(errorPayload, event) =>
                          this.handleOnError(event, errorPayload)
                        }
                        onChange={(errorPayload, date) =>
                          this.handleChangeDatePickerBirthday(date)
                        }
                      />
                    </div>
                  </div>
                  <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                    <p className="uk-text-left aps-section-contacter-fields-name">
                      Nationalité
                    </p>
                    <div className="uk-inline aps-section-register-fields-full">
                      <ValidationInput
                        className="uk-input aps-section-register-fields"
                        type="text"
                        placeholder="ex: Béninoise"
                        name="nationality"
                        onBlur={(errorPayload, event) =>
                          this.handleOnError(event, errorPayload)
                        }
                        onChange={(errorPayload, event) =>
                          this.handleSaveBeneficiaire(
                            event.target.value,
                            event.target.name,
                            beneficiairePosition - 1,
                            errorPayload
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                    <p className="uk-text-left aps-section-contacter-fields-name">
                      Sexe
                    </p>
                    <div className="uk-inline aps-section-register-fields-full">
                      <Select
                        name="sex"
                        data={{
                          "*": "Veuillez choisir dans la liste",
                          masculin: "Masculin",
                          feminin: "Feminin"
                        }}
                        onBlur={(errorPayload, event) =>
                          this.handleOnError(event, errorPayload)
                        }
                        onChange={(errorPayload, event) =>
                          this.handleSaveBeneficiaire(
                            event.target.value,
                            event.target.name,
                            beneficiairePosition - 1,
                            errorPayload
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                    <p className="uk-text-left aps-section-contacter-fields-name">
                      Taille (Cm)
                    </p>
                    <div className="uk-inline aps-section-register-fields-full">
                      <ValidationInput
                        type="text"
                        placeholder="ex: 173"
                        name="taille"
                        onBlur={(errorPayload, event) =>
                          this.handleOnError(event, errorPayload)
                        }
                        onChange={(errorPayload, event) =>
                          this.handleSaveBeneficiaire(
                            event.target.value,
                            event.target.name,
                            beneficiairePosition - 1,
                            errorPayload
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                    <p className="uk-text-left aps-section-contacter-fields-name">
                      Poids (Kg)
                    </p>
                    <div className="uk-inline aps-section-register-fields-full">
                      <ValidationInput
                        type="text"
                        placeholder="ex: 68"
                        name="poids"
                        onBlur={(errorPayload, event) =>
                          this.handleOnError(event, errorPayload)
                        }
                        onChange={(errorPayload, event) =>
                          this.handleSaveBeneficiaire(
                            event.target.value,
                            event.target.name,
                            beneficiairePosition - 1,
                            errorPayload
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                    <p className="uk-text-left aps-section-contacter-fields-name">
                      Profession
                    </p>
                    <div className="uk-inline aps-section-register-fields-full">
                      <ValidationInput
                        type="text"
                        placeholder="ex: Comptable"
                        name="profession"
                        onBlur={(errorPayload, event) =>
                          this.handleOnError(event, errorPayload)
                        }
                        onChange={(errorPayload, event) =>
                          this.handleSaveBeneficiaire(
                            event.target.value,
                            event.target.name,
                            beneficiairePosition - 1,
                            errorPayload
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                    <p className="uk-text-left aps-section-contacter-fields-name">
                      Formule santé
                    </p>
                    <div className="uk-inline aps-section-register-fields-full">
                      <Select
                        name="formule"
                        data={{
                          "*": "Veuillez choisir une Formule santé",
                          premier: "Premier",
                          vitalite: "Vitalité",
                          prestige: "Prestige"
                        }}
                        onBlur={(errorPayload, event) =>
                          this.handleOnError(event, errorPayload)
                        }
                        onChange={(errorPayload, event) =>
                          this.handleSaveBeneficiaire(
                            event.target.value,
                            event.target.name,
                            beneficiairePosition - 1,
                            errorPayload
                          )
                        }
                      />
                    </div>
                  </div>
                  <br />
                    <div className="uk-text-center aps-dashboard-beneficiare-accordion-action-btn">
                      <button
                        className="uk-button aps-btn-silver aps-btn-silver-dashboard-btn"
                        onClick={(event) => this.handleDeleteBeneficiaire(event)}
                        >
                        Supprimer
                      </button>
                    </div>
                  <br />
                </div>
              ) : (
                <div>
                  {beneficiaireData.isSouscripteurYesAdd ? (
                    <div className="answer-souscription-beneficiaire">
                      <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                        <p className="uk-text-left aps-section-contacter-fields-name">
                          Nom
                        </p>
                        <div className="uk-inline aps-section-register-fields-full">
                          <ValidationInput
                            type="text"
                            placeholder="Nom"
                            name="firstname"
                            defaultValue={
                              beneficiaireData.firstname &&
                              beneficiaireData.firstname
                            }
                            checkFullFields={
                              true
                            }
                            onBlur={(errorPayload, event) =>
                              this.handleOnError(event, errorPayload)
                            }
                            onChange={(errorPayload, event) =>
                              this.handleSaveBeneficiaire(
                                event.target.value,
                                event.target.name,
                                beneficiairePosition - 1,
                                errorPayload
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                        <p className="uk-text-left aps-section-contacter-fields-name">
                          Prénom(s)
                        </p>
                        <div className="uk-inline aps-section-register-fields-full">
                          <ValidationInput
                            type="text"
                            placeholder="Prénom(s)"
                            name="lastname"
                            defaultValue={
                              beneficiaireData.lastname &&
                              beneficiaireData.lastname
                            }
                            checkFullFields={
                              true
                            }
                            onBlur={(errorPayload, event) =>
                              this.handleOnError(event, errorPayload)
                            }
                            onChange={(errorPayload, event) =>
                              this.handleSaveBeneficiaire(
                                event.target.value,
                                event.target.name,
                                beneficiairePosition - 1,
                                errorPayload
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                        <p className="uk-text-left aps-section-contacter-fields-name">
                          Date de naissance :
                        </p>
                        <div className="uk-inline aps-section-register-fields-full aps-section-register-fields-full-date-picker">
                          <ValidationDatePicker
                            dateFormat="DD-MMM-YYYY"
                            name="birthday"
                            placeholderText="ex: 12 Mai 1991"
                            locale="fr"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            checkFullFields={
                              true
                            }
                            selected={startBirthday}
                            maxDate={moment().add(0, 'd')}
                            onBlur={(errorPayload, event) =>
                              this.handleOnError(event, errorPayload)
                            }
                            onChange={(errorPayload, date) =>
                              this.handleChangeDatePickerBirthday(date)
                            }
                          />
                        </div>
                      </div>
                      <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                        <p className="uk-text-left aps-section-contacter-fields-name">
                          Nationalité
                        </p>
                        <div className="uk-inline aps-section-register-fields-full">
                          <ValidationInput
                            className="uk-input aps-section-register-fields"
                            type="text"
                            placeholder="ex: Béninoise"
                            name="nationality"
                            defaultValue={
                              beneficiaireData.nationality &&
                              beneficiaireData.nationality
                            }
                            checkFullFields={
                              true
                            }
                            onBlur={(errorPayload, event) =>
                              this.handleOnError(event, errorPayload)
                            }
                            onChange={(errorPayload, event) =>
                              this.handleSaveBeneficiaire(
                                event.target.value,
                                event.target.name,
                                beneficiairePosition - 1,
                                errorPayload
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                        <p className="uk-text-left aps-section-contacter-fields-name">
                          Sexe
                        </p>
                        <div className="uk-inline aps-section-register-fields-full">
                          <Select
                            name="sex"
                            defaultValue={
                              beneficiaireData.sex && beneficiaireData.sex
                            }
                            data={{
                              "*": "Veuillez choisir dans la liste",
                              masculin: "Masculin",
                              feminin: "Feminin"
                            }}
                            onBlur={(errorPayload, event) =>
                              this.handleOnError(event, errorPayload)
                            }
                            onChange={(errorPayload, event) =>
                              this.handleSaveBeneficiaire(
                                event.target.value,
                                event.target.name,
                                beneficiairePosition - 1,
                                errorPayload
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                        <p className="uk-text-left aps-section-contacter-fields-name">
                          Taille (Cm)
                        </p>
                        <div className="uk-inline aps-section-register-fields-full">
                          <ValidationInput
                            type="text"
                            placeholder="ex: 173"
                            name="taille"
                            defaultValue={
                              beneficiaireData.taille && beneficiaireData.taille
                            }
                            onBlur={(errorPayload, event) =>
                              this.handleOnError(event, errorPayload)
                            }
                            onChange={(errorPayload, event) =>
                              this.handleSaveBeneficiaire(
                                event.target.value,
                                event.target.name,
                                beneficiairePosition - 1,
                                errorPayload
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                        <p className="uk-text-left aps-section-contacter-fields-name">
                          Poids (Kg)
                        </p>
                        <div className="uk-inline aps-section-register-fields-full">
                          <ValidationInput
                            type="text"
                            placeholder="ex: 68"
                            name="poids"
                            defaultValue={
                              beneficiaireData.poids && beneficiaireData.poids
                            }
                            onBlur={(errorPayload, event) =>
                              this.handleOnError(event, errorPayload)
                            }
                            onChange={(errorPayload, event) =>
                              this.handleSaveBeneficiaire(
                                event.target.value,
                                event.target.name,
                                beneficiairePosition - 1,
                                errorPayload
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                        <p className="uk-text-left aps-section-contacter-fields-name">
                          Profession
                        </p>
                        <div className="uk-inline aps-section-register-fields-full">
                          <ValidationInput
                            type="text"
                            placeholder="ex: Comptable"
                            name="profession"
                            defaultValue={
                              beneficiaireData.profession &&
                              beneficiaireData.profession
                            }
                            onBlur={(errorPayload, event) =>
                              this.handleOnError(event, errorPayload)
                            }
                            onChange={(errorPayload, event) =>
                              this.handleSaveBeneficiaire(
                                event.target.value,
                                event.target.name,
                                beneficiairePosition - 1,
                                errorPayload
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                        <p className="uk-text-left aps-section-contacter-fields-name">
                          Formule santé
                        </p>
                        <div className="uk-inline aps-section-register-fields-full">
                          <Select
                            name="formule"
                            data={{
                              "*": "Veuillez choisir une Formule santé",
                              premier: "Premier",
                              vitalite: "Vitalité",
                              prestige: "Prestige"
                            }}
                            defaultValue={
                              beneficiaireData.formule &&
                              beneficiaireData.formule
                            }
                            onBlur={(errorPayload, event) =>
                              this.handleOnError(event, errorPayload)
                            }
                            onChange={(errorPayload, event) =>
                              this.handleSaveBeneficiaire(
                                event.target.value,
                                event.target.name,
                                beneficiairePosition - 1,
                                errorPayload
                              )
                            }
                          />
                        </div>
                      </div>
                      <br />
                        <div className="uk-text-center aps-dashboard-beneficiare-accordion-action-btn">
                          <button
                            className="uk-button aps-btn-silver aps-btn-silver-dashboard-btn"
                            onClick={(event) => this.handleDeleteBeneficiaire(event)}
                            >
                            Supprimer
                          </button>
                        </div>
                      <br />
                    </div>
                  ) : (
                    <div>
                      {!hasSouscripteurAdded ? (
                        <div className="question-souscription-beneficiaire">
                          <div className="uk-text-center aps-dashboard-beneficiare-accordion-subtitle">
                            Êtes-vous le souscripteur ?
                          </div>
                          <div className="uk-text-center aps-dashboard-beneficiare-accordion-action-btn">
                            <button
                              className="uk-button aps-btn-silver aps-btn-silver-dashboard-btn aps-btn-silver-dashboard-btn-yes-no"
                              onClick={event =>
                                this.handleSouscripteurYesAdd(event)
                              }
                            >
                              Oui
                            </button>
                            <button
                              className="uk-button aps-btn-silver aps-btn-silver-dashboard-btn aps-btn-silver-dashboard-btn-yes-no"
                              onClick={event => this.handleSouscripteurNoAdd(event)}
                            >
                              Non
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="answer-souscription-beneficiaire">
                          <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">
                              Lien de parenté ou professionnel
                            </p>
                            <div className="uk-inline aps-section-register-fields-full">
                              <Select
                                defaultValue={
                                  beneficiaireData.lien && beneficiaireData.lien
                                }
                                name="lien"
                                data={(isEntreprise && beneficiairePosition === 1) ? {
                                  "*": "Veuillez choisir un lien de parenté",
                                  employe: "Employé",
                                  conjoint: "Conjoint",
                                  enfant: "Enfant",
                                } : (isEntreprise && beneficiairePosition !== 1) ? {
                                  "*": "Veuillez choisir un lien de parenté",
                                  conjoint: "Conjoint",
                                  enfant: "Enfant",
                                } : {
                                  "*": "Veuillez choisir un lien de parenté",
                                  assurePrincipal: "Assuré principal",
                                  conjoint: "Conjoint",
                                  enfant: "Enfant",
                                  employe: "Employé",
                                  autre: "Autre",
                                }}
                                onBlur={(errorPayload, event) =>
                                  this.handleOnError(event, errorPayload)
                                }
                                onChange={(errorPayload, event) =>
                                  this.handleSaveBeneficiaire(
                                    event.target.value,
                                    event.target.name,
                                    beneficiairePosition - 1,
                                    errorPayload
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">
                              Nom
                            </p>
                            <div className="uk-inline aps-section-register-fields-full">
                              <ValidationInput
                                type="text"
                                placeholder="Nom"
                                name="firstname"
                                defaultValue={
                                  beneficiaireData.firstname &&
                                  beneficiaireData.firstname
                                }
                                onBlur={(errorPayload, event) =>
                                  this.handleOnError(event, errorPayload)
                                }
                                onChange={(errorPayload, event) =>
                                  this.handleSaveBeneficiaire(
                                    event.target.value,
                                    event.target.name,
                                    beneficiairePosition - 1,
                                    errorPayload
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">
                              Prénom(s)
                            </p>
                            <div className="uk-inline aps-section-register-fields-full">
                              <ValidationInput
                                type="text"
                                placeholder="Prénom(s)"
                                name="lastname"
                                defaultValue={
                                  beneficiaireData.lastname &&
                                  beneficiaireData.lastname
                                }
                                onBlur={(errorPayload, event) =>
                                  this.handleOnError(event, errorPayload)
                                }
                                onChange={(errorPayload, event) =>
                                  this.handleSaveBeneficiaire(
                                    event.target.value,
                                    event.target.name,
                                    beneficiairePosition - 1,
                                    errorPayload
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">
                              Date de naissance :
                            </p>
                            <div className="uk-inline aps-section-register-fields-full aps-section-register-fields-full-date-picker">
                              <ValidationDatePicker
                                dateFormat="DD-MMM-YYYY"
                                name="birthday"
                                placeholderText="ex: 12 Mai 1991"
                                locale="fr"
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                selected={startBirthday}
                                maxDate={moment().add(0, 'd')}
                                onBlur={(errorPayload, event) =>
                                  this.handleOnError(event, errorPayload)
                                }
                                onChange={(errorPayload, date) =>
                                  this.handleChangeDatePickerBirthday(date)
                                }
                              />
                            </div>
                          </div>
                          <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">
                              Nationalité
                            </p>
                            <div className="uk-inline aps-section-register-fields-full">
                              <ValidationInput
                                className="uk-input aps-section-register-fields"
                                type="text"
                                placeholder="ex: Béninoise"
                                name="nationality"
                                defaultValue={
                                  beneficiaireData.nationality &&
                                  beneficiaireData.nationality
                                }
                                onBlur={(errorPayload, event) =>
                                  this.handleOnError(event, errorPayload)
                                }
                                onChange={(errorPayload, event) =>
                                  this.handleSaveBeneficiaire(
                                    event.target.value,
                                    event.target.name,
                                    beneficiairePosition - 1,
                                    errorPayload
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">
                              Sexe
                            </p>
                            <div className="uk-inline aps-section-register-fields-full">
                              <Select
                                name="sex"
                                defaultValue={
                                  beneficiaireData.sex && beneficiaireData.sex
                                }
                                data={{
                                  "*": "Veuillez choisir dans la liste",
                                  masculin: "Masculin",
                                  feminin: "Feminin"
                                }}
                                onBlur={(errorPayload, event) =>
                                  this.handleOnError(event, errorPayload)
                                }
                                onChange={(errorPayload, event) =>
                                  this.handleSaveBeneficiaire(
                                    event.target.value,
                                    event.target.name,
                                    beneficiairePosition - 1,
                                    errorPayload
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">
                              Taille (Cm)
                            </p>
                            <div className="uk-inline aps-section-register-fields-full">
                              <ValidationInput
                                type="text"
                                placeholder="ex: 173"
                                name="taille"
                                defaultValue={
                                  beneficiaireData.taille && beneficiaireData.taille
                                }
                                onBlur={(errorPayload, event) =>
                                  this.handleOnError(event, errorPayload)
                                }
                                onChange={(errorPayload, event) =>
                                  this.handleSaveBeneficiaire(
                                    event.target.value,
                                    event.target.name,
                                    beneficiairePosition - 1,
                                    errorPayload
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">
                              Poids (Kg)
                            </p>
                            <div className="uk-inline aps-section-register-fields-full">
                              <ValidationInput
                                type="text"
                                placeholder="ex: 68"
                                name="poids"
                                defaultValue={
                                  beneficiaireData.poids && beneficiaireData.poids
                                }
                                onBlur={(errorPayload, event) =>
                                  this.handleOnError(event, errorPayload)
                                }
                                onChange={(errorPayload, event) =>
                                  this.handleSaveBeneficiaire(
                                    event.target.value,
                                    event.target.name,
                                    beneficiairePosition - 1,
                                    errorPayload
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">
                              Profession
                            </p>
                            <div className="uk-inline aps-section-register-fields-full">
                              <ValidationInput
                                type="text"
                                placeholder="ex: Comptable"
                                name="profession"
                                defaultValue={
                                  beneficiaireData.profession &&
                                  beneficiaireData.profession
                                }
                                onBlur={(errorPayload, event) =>
                                  this.handleOnError(event, errorPayload)
                                }
                                onChange={(errorPayload, event) =>
                                  this.handleSaveBeneficiaire(
                                    event.target.value,
                                    event.target.name,
                                    beneficiairePosition - 1,
                                    errorPayload
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="aps-section-register-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">
                              Formule santé
                            </p>
                            <div className="uk-inline aps-section-register-fields-full">
                              <Select
                                name="formule"
                                data={{
                                  "*": "Veuillez choisir une Formule santé",
                                  premier: "Premier",
                                  vitalite: "Vitalité",
                                  prestige: "Prestige"
                                }}
                                defaultValue={
                                  beneficiaireData.formule &&
                                  beneficiaireData.formule
                                }
                                onBlur={(errorPayload, event) =>
                                  this.handleOnError(event, errorPayload)
                                }
                                onChange={(errorPayload, event) =>
                                  this.handleSaveBeneficiaire(
                                    event.target.value,
                                    event.target.name,
                                    beneficiairePosition - 1,
                                    errorPayload
                                  )
                                }
                              />
                            </div>
                          </div>
                          <br />
                            <div className="uk-text-center aps-dashboard-beneficiare-accordion-action-btn">
                              <button
                                className="uk-button aps-btn-silver aps-btn-silver-dashboard-btn"
                                onClick={(event) => this.handleDeleteBeneficiaire(event)}
                                >
                                Supprimer
                              </button>
                            </div>
                          <br />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </li>
    );
  }
}

export default BeneficiaireBox;



// WEBPACK FOOTER //
// ./src/components/BeneficiaireBox/index.js